import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

import HeroSection from "./blocks/hero-section/HeroSection";
import ComparisonSection from "./blocks/comparison-section/ComparisonSection";
import HowItWorksSection from "./blocks/how-it-works-section/HowItWorksSection";
import CardCarouselSection from "./blocks/card-carousel-section/CardCarouselSection";
import CallToActionSection from "./blocks/call-to-action-section/CallToActionSection";
import ChecklistSection from "./blocks/checklist-section/ChecklistSection";
import ConnectorCarouselSection from "./blocks/connector-carousel-section/ConnectorCarouselSection";
import IconListSection from "./blocks/icon-list-section/IconListSection";
import Contacts from "./blocks/contacts/Contacts";
import styles from './Partners.module.scss';
import PresentSection from "./blocks/present-section/PresentSection";
import {getPartnerLanguage} from './locales/language';
import type {PartnerVariant} from './types';

type PartnersProps = {
    variant?: PartnerVariant;
};

function Partners({variant = 'transport'}: PartnersProps) {
    const {pathname} = useLocation();
    const language = getPartnerLanguage(pathname);

    const [backgroundContainer, setBackgroundContainer] = useState<HTMLDivElement | null>(null);

    useEffect(() => {
        const previousLanguage = document.documentElement.lang;

        document.documentElement.lang = language;

        return () => {
            document.documentElement.lang = previousLanguage;
        };
    }, [language]);

    return (
        <div className={styles.page} lang={language}>
            <div className={styles.background} ref={setBackgroundContainer} aria-hidden="true"/>
            <HeroSection backgroundContainer={backgroundContainer} variant={variant}/>
            <ComparisonSection variant={variant}/>
            <HowItWorksSection variant={variant} callToActionText="Focus on turning qualified requests into deals, instead of handling cold inquiries"/>
            <CardCarouselSection/>
            <CallToActionSection text="Your rates, right where decisions happen"/>
            <ChecklistSection/>
            <ConnectorCarouselSection/>
            <PresentSection/>
            <IconListSection variant={variant}/>
            <Contacts/>
        </div>
    );
}

export default Partners
